// This is a higher order component to use with a goody that is positioned relative to the animal.
// ie. Raybans.js

// To use this, simply make sure you have the marker in your SVG.
// example: <circle ref={POSITIONED_GOODY_REFS.MARKER} cx="YOURCOORDS" cy="YOURCOORDS" r="0"/>.
// See Test.js for example


import React from 'react';
import PropTypes from 'prop-types';

import { POSITIONED_GOODY_REFS } from '../../../constants';

class PositionedGoodyHOC extends React.Component {
	componentDidMount() {
		this.props.getMarkerCoords(this.refs[POSITIONED_GOODY_REFS.MARKER]);
	}
}

PositionedGoodyHOC.PropTypes = {
	getMarkerCoords: PropTypes.func,
};

PositionedGoodyHOC.defaultProps = {
	getMarkerCoords: null,
};

export default PositionedGoodyHOC;



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/PositionedGoodyHOC.js